import { SidebarPortal } from '@plone/volto/components';
import { withBlockExtensions } from '@plone/volto/helpers';
import CardSidebar from './Sidebar';
import View from './View';

interface HeadingEditProps {
  block: string;
  data: {
    heading?: string;
    tag?: string;
    alignment?: string;
    showUnderline?: boolean;
  };
  onChangeBlock: (block: string, data: any) => void;
  onSelectBlock: (block: string) => void;
  onAddBlock: (type: string, index: number) => string;
  onFocusPreviousBlock: (block: string, node: any) => void;
  onFocusNextBlock: (block: string, node: any) => void;
  selected: boolean;
  index: number;
  [key: string]: any; // Add index signature for any other props
}

const IframeEdit = (props: HeadingEditProps) => {
  const { block, data, onChangeBlock, selected } = props;

  return (
    <>
      <View {...props} isEditMode />
      {/* @ts-ignore - Ignore TS errors for SidebarPortal component */}
      <SidebarPortal selected={selected}>
        <CardSidebar
          {...props}
          data={data}
          block={block}
          onChangeBlock={onChangeBlock}
        />
      </SidebarPortal>
    </>
  );
};

export default withBlockExtensions(IframeEdit);
